import { ChevronUp } from 'baseui/icon'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import MessageBody from '../MessageBody/MessageBody'
import { HomeMessage, MessageLabels } from '../types'
import useExpandedMessage from './useExpandedMessage'
import {
  FullRow,
  MessagePanel,
  MessagePanelContent,
  MessagePanelFooter,
  MessagePanelHeader,
  closeButtonOverrides,
} from './styled-components'

interface ExpandedMessageProps {
  hidden: boolean
  message: HomeMessage | null
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const ExpandedMessage = ({ hidden, message, labels, onToggle }: ExpandedMessageProps) => {
  const { title, closeLabel, onClose } = useExpandedMessage({ message, labels, onToggle })

  if (hidden || message === null) return null

  return (
    <FullRow>
      <MessagePanel id={`home-message-panel-${message.id}`}>
        <MessagePanelHeader>{title}</MessagePanelHeader>
        <MessagePanelContent>
          <MessageBody content={message.content} />
        </MessagePanelContent>
        <MessagePanelFooter>
          {/* @ts-ignore */}
          <SDButton
            id={`home-message-close-${message.id}`}
            kind='secondary'
            overrides={closeButtonOverrides}
            startEnhancer={<ChevronUp size={18} />}
            onClick={onClose}
          >
            {closeLabel}
          </SDButton>
        </MessagePanelFooter>
      </MessagePanel>
    </FullRow>
  )
}

export default ExpandedMessage
